import { reactive } from "vue";
import type {  FormRules } from "element-plus";

import { IParameter } from "./parameter";
import { ITraceable } from "./_traceable";

interface IBaseCenter extends ITraceable {
    code: string;
    approval?: string;
    numCenter? : number;
    name?: string;
    isActive: boolean;
}

interface ICenter extends IBaseCenter {
    // ID properties for hydration
    speciesId: number;
    typologyId?: number;
    societyId?: number;
    countryId?: number;
    parentId?: number;

    // Navigation properties (hydrated by frontend)
    species: IParameter;
    typology?: IParameter;
    society?: IParameter;
    country?: IParameter;
    parent?: ICenter;

    // TODO a trouver autre chose, ne se trouve pas dans l'objet de base mais utilisé dans un viewModel
    icon : string;
}

interface ICenterPDTO extends IBaseCenter {
    speciesId: number;
    typologyId?: number;
    societyId?: number;
    countryId?: number;
    parentId?: number;
}

class CenterAuthorize {
    value?: string;
    label?: string;
    center:ICenter = {} as ICenter;
    fav: boolean = false;
    quarantaine: boolean = false;
    sortingCenter: string = "";
}

const rulesCenter = reactive<FormRules>({
    code: [
        { required: true, message: "Please input the name", trigger: "blur" },
        { min: 3, max: 40, message: "Length should be 3 to 5", trigger: "blur" },
    ],
});

const KeyCenter = {
    id: "id",
    nom: "name",
    valeur: "code",
}

export { type ICenter, type ICenterPDTO, rulesCenter, KeyCenter , CenterAuthorize };
